import React, { memo, useCallback } from 'react';
import { Button, FormField, Input } from 'semantic-ui-react';
import styled from 'styled-components';

const StyledClearableInput = styled(FormField)`
    position: relative;

    input,
    .ui[class*="left icon"].input > input {
        padding-right: 1.7142857142857142rem !important;
    }

    &.ultra-compact .ui.button:last-child {
        bottom: 1.1rem;
    }

    .ui.button:last-child {
        position: absolute;
        right: 0.42857142857142855rem;
        bottom: 1.3571428571428572rem;
        transform: translateY(50%);
        color: #222222;
        font-size: 0.8571428571428571rem;
    }
`;

const ClearableInput = ({
    compact,
    label,
    name,
    value,
    onChange,
    withSort,
    sizer,
    formFieldProps = {},
    ...props
}) => {
    const handleClear = useCallback(
        (e) => {
            onChange(e, { name, value: '' });
        },
        [name, onChange]
    );

    return (
        <StyledClearableInput
            {...compact ? { className: 'ultra-compact' } : {}}>
            {label != null && (<label>{label}</label>)}
            <Input
                className={withSort ? 'filter-with-sort' : ''}
                fluid
                {...props}
                value={value}
                name={name}
                onChange={onChange}
            />
            {sizer && <div className='sizer'>{value}</div>}
            {!!value && (
                <Button
                    className={`simple ${withSort ? 'with-sort' : ''}`}
                    icon="close"
                    onClick={handleClear}
                />
            )}
        </StyledClearableInput>
    );
};

export default memo(ClearableInput);



// WEBPACK FOOTER //
// ./App/components/Input/ClearableInput.jsx